import {ReactNode} from 'react';
import ReactModal from 'react-modal';
import qtCloseIcon from '../../../assets/images/qt-close.png';
import './modal.sass';

type TProps = {
  size?: 'small';
  type?: 'default' | 'qt';
  isOpen: boolean;
  onRequestClose: () => void;
  children: ReactNode;
};
const styles = {
  default: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    border: 'none',
    borderRadius: '40px',
    background: '#0A132C',
    padding: '18px',
    outline: 'none',
  },
  qt: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    border: 'none',
    borderRadius: '40px',
    background: '#171B27',
    padding: '36px',
    // width: '500px',
    outline: 'none',
  },
  overlay: {
    zIndex: 10,
    background: 'rgba(12, 13, 14, 0.7)',
  },
};

function Modal({size, children, onRequestClose, type = 'default', ...props}: TProps) {
  return (
    <ReactModal
      style={{
        ...styles,
        content: {...styles[type], maxWidth: size === 'small' ? 540 : 700},
      }}
      onRequestClose={onRequestClose}
      {...props}
      className="modal"
    >
      <div className="modal__close" onClick={onRequestClose}>
        {type === 'qt' && <img src={qtCloseIcon} alt="close" />}
      </div>
      <div className="modal__body">{children}</div>
    </ReactModal>
  );
}

export default Modal;
